//switch product's variants
$(".event-sale-pre-product .variant-item").click(function () {
  var vid = $(this).attr("data-id");
  var vindex = $(this).attr("data-index");
  var pid = $(this).attr("data-pid");
  $(this).addClass("active").siblings().removeClass("active");
  $(".event-sale-pre-product .variant-wrapper[data-id=" + vid + "]")
    .addClass("active")
    .siblings()
    .removeClass("active");
  $(
    ".event-sale-pre-product .variant-img[data-index=" +
      vindex +
      "][data-pid=" +
      pid +
      "]",
  )
    .addClass("active")
    .siblings()
    .removeClass("active");

  $(
    ".event-sale-pre-product .buy-card .price[data-index=" +
      vindex +
      "][data-pid=" +
      pid +
      "]",
  )
    .addClass("active")
    .siblings()
    .removeClass("active");

  updateGiftByIndex($(this).closest(".event-sale-pre-product"), vindex);

  if (window.innerWidth <= 768) {
    if (vid == "46577894949089") {
      $(
        ".event-sale-pre-product .product-box .buy-card .product-benefit-img",
      ).hide();
      $(
        ".event-sale-pre-product .product-box .buy-card .product-benefit-img.mb-black",
      ).show();
    } else if (vid == "46577894981857") {
      $(
        ".event-sale-pre-product .product-box .buy-card .product-benefit-img",
      ).hide();
      $(
        ".event-sale-pre-product .product-box .buy-card .product-benefit-img.mb-white",
      ).show();
    }
  }
});

function parseGiftVariants(raw) {
  if (!raw) return [];

  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    try {
      const decoded = $("<textarea />").html(raw).text();
      const parsed = JSON.parse(decoded);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e2) {
      return [];
    }
  }
}

function updateGiftByIndex($root, vindex) {
  if (!$root || !$root.length) return;

  const indexNum = Number.parseInt(vindex, 10);
  const safeIndex = Number.isFinite(indexNum) ? indexNum : 0;

  const $gifts = $root.find(".event-sale-pre-gift-container");
  if (!$gifts.length) return;

  $gifts.each(function () {
    const $gift = $(this);

    const variants = parseGiftVariants($gift.attr("data-variants"));
    const matched = variants.find(
      (v) => Number.parseInt(v.index, 10) === safeIndex,
    );
    const fallback = variants.find((v) => Number.parseInt(v.index, 10) === 0);
    const item = matched || fallback;

    const percentText = (item && item.gift__inventory_percent) || "0%";
    const quantityText = (item && item.gift__inventory_quantity) || "0";
    $gift.find(".event-sale-pre-gift__inventory_quantity").text(quantityText);

    const widthPercent = Math.max(
      0,
      Math.min(100, Number.parseFloat(percentText) || 0),
    );
    $gift
      .find(".event-sale-pre-gift__inventory_bar_fill")
      .removeAttr("hidden")
      .css("width", widthPercent + "%");

    const $imgs = $gift.find(".event-sale-pre-gift__image_item");
    if ($imgs.length) {
      $imgs.attr("data-active", "false");
      const $byIndex = $imgs
        .filter("[data-index='" + safeIndex + "']")
        .first();
      ($byIndex.length ? $byIndex : $imgs.first()).attr(
        "data-active",
        "true",
      );
    }
  });
}
if (!isMobile) {
  let isMobile = window.innerWidth <= 768;
}

function toggleImg(isMobile) {
  const $img = $(
    ".event-sale-pre-product .product-box .buy-card .product-benefit-img",
  );
  isMobile ? $img.show() : $img.hide();
}

// 初始化
toggleImg(isMobile);

window.addEventListener("resize", () => {
  const nowMobile = window.innerWidth <= 768;

  // 只有跨过 768 才执行
  if (isMobile !== nowMobile) {
    toggleImg(nowMobile);
  }

  isMobile = nowMobile;
});

// 阻止跳转加购
$(function () {
  $(".event-sale-pre-product .add-to-cart-form2").on("submit", function (evt) {
    evt.preventDefault();
    ShopifyAPI.addItemFromForm2(
      evt.target,
      ajaxCart.itemAddedCallback,
      ajaxCart.itemErrorCallback,
    );
  });

  $(".event-sale-pre-product").each(function () {
    const $root = $(this);
    const $active = $root.find(".variant-item.active").first();
    const index = ($active.length ? $active.attr("data-index") : null) || "0";
    updateGiftByIndex($root, index);
  });
});

//openmeet 切换控制
$(".event-sale-pre-product .openmeet .toggle-product-option-item").click(
  function () {
    $(this).addClass("active").siblings().removeClass("active");
    var $this = $(this);
    setTimeout(function () {
      //usb-a 和 usb-c 和 no
      var now_product = $this.attr("data-product-handle");
      var now_type = $this.attr("data-option-size");

      $(
        ".event-sale-pre-product .toggle-product-option-size .toggle-product-option-item[data-product-handle='" +
          now_product +
          "']",
      )
        .addClass("active")
        .siblings()
        .removeClass("active");

      $(".event-sale-pre-product ." + now_product + " .color_list li").css(
        "display",
        "none",
      );
      $(
        ".event-sale-pre-product ." +
          now_product +
          " .color_list li[data-option2='" +
          now_type +
          "']",
      ).css("display", "block");
      var v_id = $(
        ".event-sale-pre-product ." +
          now_product +
          " .color_list li[data-option2='" +
          now_type +
          "']",
      )
        .eq(0)
        .attr("data-var_id");
      $(
        ".event-sale-pre-product ." +
          now_product +
          " .color_list li[data-option2='" +
          now_type +
          "'][data-var_id='" +
          v_id +
          "']",
      ).click();
    }, 100);
  },
);

//opencomm2uc2025upgrade 切换控制
$(
  ".event-sale-pre-product .opencomm2uc2025upgrade .toggle-product-option-item",
).click(function () {
  $(this).addClass("active").siblings().removeClass("active");
  var $this = $(this);
  setTimeout(function () {
    //usb-a 和 usb-c
    var now_product = $this.attr("data-product-handle");
    var now_type = $this.attr("data-option-size");

    $(
      ".event-sale-pre-product .toggle-product-option-size .toggle-product-option-item[data-product-handle='" +
        now_product +
        "']",
    )
      .addClass("active")
      .siblings()
      .removeClass("active");

    $(".event-sale-pre-product ." + now_product + " .color_list li").css(
      "display",
      "none",
    );
    $(
      ".event-sale-pre-product ." +
        now_product +
        " .color_list li[data-option2='" +
        now_type +
        "']",
    ).css("display", "block");
    var v_id = $(
      ".event-sale-pre-product ." +
        now_product +
        " .color_list li[data-option2='" +
        now_type +
        "']",
    )
      .eq(0)
      .attr("data-var_id");
    $(
      ".event-sale-pre-product ." +
        now_product +
        " .color_list li[data-option2='" +
        now_type +
        "'][data-var_id='" +
        v_id +
        "']",
    ).click();
  }, 100);
});

//openrun size 切换控制
$(".event-sale-pre-product .openrun .toggle-product-option-item").click(
  function () {
    $(this).addClass("active").siblings().removeClass("active");
    var $this = $(this);
    setTimeout(function () {
      //mini standard
      if ($this.hasClass("toggle-product-size-item")) {
        var now_product = $this.attr("data-product-handle");
        var now_size = $this.attr("data-option-size");
        var now_type = $(
          `.event-sale-pre-product .${now_product} .charger-port-part .toggle-product-option-item.active`,
        ).attr("data-option-size");
      } else {
        //usb-c 和 磁吸
        var now_product = $this.attr("data-product-handle");
        var now_size = $(
          `.event-sale-pre-product .${now_product} .toggle-product-option-size .toggle-product-option-item.active`,
        ).attr("data-option-size");
        var now_type = $this.attr("data-option-size");
      }
      $(
        ".event-sale-pre-product .toggle-product-option-size .toggle-product-option-item[data-product-handle='" +
          now_product +
          "'][data-option-size='" +
          now_size +
          "']",
      )
        .addClass("active")
        .siblings()
        .removeClass("active");

      $(".event-sale-pre-product ." + now_product + " .color_list li").css(
        "display",
        "none",
      );
      $(
        ".event-sale-pre-product ." +
          now_product +
          " .color_list li[data-option-size='" +
          now_size +
          "'][data-option2='" +
          now_type +
          "']",
      ).css("display", "block");
      var v_id = $(
        ".event-sale-pre-product ." +
          now_product +
          " .color_list li[data-option-size='" +
          now_size +
          "'][data-option2='" +
          now_type +
          "']",
      )
        .eq(0)
        .attr("data-var_id");
      $(
        ".event-sale-pre-product ." +
          now_product +
          " .color_list li[data-option-size='" +
          now_size +
          "'][data-option2='" +
          now_type +
          "'][data-var_id='" +
          v_id +
          "']",
      ).click();
    }, 100);
  },
);

//Openrun pro2 mini产品切换
$(".event-sale-pre-product .openrun-pro2 .toggle-product-option-item").click(
  function () {
    $(this).addClass("active").siblings().removeClass("active");
    var $this = $(this);
    setTimeout(function () {
      //mini standard
      var now_product = $this.attr("data-product-handle");
      var now_size = $this.attr("data-option-size");
      $(
        ".event-sale-pre-product .toggle-product-option-size .toggle-product-option-item[data-product-handle='" +
          now_product +
          "'][data-option-size='" +
          now_size +
          "']",
      )
        .addClass("active")
        .siblings()
        .removeClass("active");

      $(".event-sale-pre-product ." + now_product + " .color_list li").css(
        "display",
        "none",
      );
      $(
        ".event-sale-pre-product ." +
          now_product +
          " .color_list li[data-option-size='" +
          now_size +
          "']",
      ).css("display", "block");
      var v_id = $(
        ".event-sale-pre-product ." +
          now_product +
          " .color_list li[data-option-size='" +
          now_size +
          "']",
      )
        .eq(0)
        .attr("data-var_id");
      $(
        ".event-sale-pre-product ." +
          now_product +
          " .color_list li[data-option-size='" +
          now_size +
          "'][data-var_id='" +
          v_id +
          "']",
      ).click();
    }, 100);
  },
);

// 自定义优先展示变体
$(".event-sale-pre-product .product-box").each(function () {
  const $this = $(this);
  const variantIndex = $this.data('variant-index');
  if (variantIndex) {
    $this.find('.variant-item').eq(variantIndex - 1).trigger('click');
  }
});

// {% comment %} 产品加购埋点 {% endcomment %}
function page_product_ga4_deal(
  product_item,
  buttom_name,
  event_name,
  discount = 0,
) {
  let $v_item_name = "";
  let $v_item_variant = "";
  let $v_item_category = "";
  let $v_item_category2 = "Standard";
  if (product_handle_map.has(product_item[0])) {
    $v_item_name = product_handle_valueMap[product_item[0]][0];
    $v_item_variant = product_handle_valueMap[product_item[0]][1];
    $v_item_category = product_handle_valueMap[product_item[0]][2];
    $v_item_category2 = product_handle_valueMap[product_item[0]][3];
  }

  window.dataLayer.push({ event_parameters: null });
  window.dataLayer.push({
    event: "ga4Event",
    event_name: event_name,
    event_parameters: {
      item_list_id: product_item[3],
      item_list_name: product_item[4],
      currency: "AUD",
      button_name: buttom_name,
      items: [
        {
          item_id: product_item[0],
          item_name: $v_item_name,
          index: 1,
          item_list_id: product_item[3],
          item_list_name: product_item[4],
          item_category: $v_item_category,
          item_category2: $v_item_category2,
          item_category3: product_item[6].replace("Default Title", "none"),
          item_variant: $v_item_variant,
          item_brand: "SHOKZ",
          price: Number(
            product_item[9].split("$").join("").split(",").join("."),
          ),
          quantity: Number(product_item[10]),
          currency: "AUD",
          discount: discount,
        },
      ],
    },
  });
}

function getDiscount($trigger) {
  const $buyCard = $trigger.closest(".buy-card");
  const priceText = $buyCard
    .find(".price.active")
    .clone()
    .children()
    .remove()
    .end()
    .text()
    .replace(/[^\d.]/g, "");

  const compareText = $buyCard
    .find(".price.active .tag_sale-compare-price")
    .text()
    .replace(/[^\d.]/g, "");

  const price = parseFloat(priceText) || 0;
  const compare_at_price = parseFloat(compareText) || 0;

  const discount =
    compare_at_price > price ? +(compare_at_price - price).toFixed(2) : 0;
  return discount;
}

$(
  ".event-sale-pre-product .buy-card .variant-buttons .addtocart",
)
  .off("click.eventSalePreProduct")
  .on("click.eventSalePreProduct", function () {
    let product_item = $(this).attr("data-product-data");
    product_item = product_item.split("::");
    page_product_ga4_deal(
      product_item,
      $(this).text().trim(),
      "add_to_cart",
      getDiscount($(this)),
    );
  });

$(".event-sale-pre-product .buy-card .product-link")
  .off("click.eventSalePreProduct")
  .on("click.eventSalePreProduct", function () {
    let product_item = getEventSalePreProductBuyCardDataString(
      $(this).closest(".buy-card"),
    );
    if (!product_item) return;
    product_item = product_item.split("::");
    page_product_ga4_deal(
      product_item,
      "Product link",
      "select_item",
      getDiscount($(this)),
    );
  });

$(".event-sale-pre-product .buy-card .product-title")
  .off("click.eventSalePreProduct")
  .on("click.eventSalePreProduct", function () {
    let product_item = getEventSalePreProductBuyCardDataString(
      $(this).closest(".buy-card"),
    );
    if (!product_item) return;
    product_item = product_item.split("::");
    page_product_ga4_deal(
      product_item,
      "Product title",
      "select_item",
      getDiscount($(this)),
    );
  });

$(".event-sale-pre-product .buy-card .variants-img-wrapper")
  .off("click.eventSalePreProduct")
  .on("click.eventSalePreProduct", function () {
    let product_item = getEventSalePreProductBuyCardDataString(
      $(this).closest(".buy-card"),
    );
    if (!product_item) return;
    product_item = product_item.split("::");
    page_product_ga4_deal(
      product_item,
      "Product Image link",
      "select_item",
      getDiscount($(this)),
    );
  });

// 曝光埋点
function getEventSalePreProductBuyCardDataString(buyCardRoot) {
  const $buyCard =
    buyCardRoot && buyCardRoot.nodeType === 1
      ? $(buyCardRoot)
      : $(buyCardRoot);
  let $div = $buyCard.find(".variant-wrapper.active .product-data-div");
  if (!$div.length) {
    $div = $buyCard.find(".product-data-div").first();
  }
  return $div.attr("data-product-data") || "";
}

var record_export_collection_eventSalePreProduct = new Set();
var time_interval_eventSalePreProduct = -1;
var home_product_list_attr_eventSalePreProduct = [];
function eventSalePreProduct_home_product_ga4_deal_list(collection) {
  clearInterval(time_interval_eventSalePreProduct);
  let groupedItems = {};
  let collection_item = "";
  collection.forEach((element, index) => {
    const raw =
      typeof element === "string"
        ? element
        : getEventSalePreProductBuyCardDataString(element);
    if (!raw) return;
    collection_item = raw.split("::");
    let $v_item_name = "";
    let $v_item_variant = "";
    let $v_item_category = "";
    let $v_item_category2 = "Standard";
    if (product_handle_map.has(collection_item[0])) {
      $v_item_name = product_handle_valueMap[collection_item[0]][0];
      $v_item_variant = product_handle_valueMap[collection_item[0]][1];
      $v_item_category = product_handle_valueMap[collection_item[0]][2];
      $v_item_category2 = product_handle_valueMap[collection_item[0]][3];
    }

    let arr_item = {
      item_id: collection_item[0],
      item_name: $v_item_name,
      index: collection_item[2],
      item_list_id: collection_item[4],
      item_list_name: collection_item[4],
      item_category: $v_item_category,
      item_category2: $v_item_category2,
      item_category3: collection_item[6].replace("Default Title", "none"),
      item_variant: $v_item_variant,
      item_brand: "SHOKZ",
      price: Number(
        collection_item[9].split("$").join("").split(",").join("."),
      ),
      quantity: Number(collection_item[10]),
      currency: "AUD",
    };
    if (!groupedItems[collection_item[4].split(" ").join("")]) {
      groupedItems[collection_item[4].split(" ").join("")] = [];
    }
    groupedItems[collection_item[4].split(" ").join("")].push(arr_item);
  });

  for (const itemListId in groupedItems) {
    if (groupedItems.hasOwnProperty(itemListId)) {
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: "ga4Event",
        event_name: "view_item_list",
        event_parameters: {
          currency: "AUD",
          item_list_id: groupedItems[itemListId][0]["item_list_name"],
          item_list_name: groupedItems[itemListId][0]["item_list_name"],
          items: groupedItems[itemListId],
        },
      });
    }
  }
}

if (!window.__eventSalePreProductBuyCardIO) {
  window.__eventSalePreProductBuyCardIO = true;
  var observer_event_sale_pre_product = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let product_item = getEventSalePreProductBuyCardDataString(
          entry.target,
        );
        if (!product_item) {
          observer_event_sale_pre_product.unobserve(entry.target);
          return;
        }

        product_item = product_item.split("::");
        let product_item_record = product_item[3] + product_item[8];
        product_item_record = product_item_record.split(" ").join("-");

        if (!record_export_collection_eventSalePreProduct.has(product_item_record)) {
          record_export_collection_eventSalePreProduct.add(product_item_record);
          home_product_list_attr_eventSalePreProduct.push(entry.target);
          clearInterval(time_interval_eventSalePreProduct);
          time_interval_eventSalePreProduct = setInterval(function () {
            clearInterval(time_interval_eventSalePreProduct);
            eventSalePreProduct_home_product_ga4_deal_list(
              home_product_list_attr_eventSalePreProduct,
            );
            home_product_list_attr_eventSalePreProduct = [];
          }, 3000);
        }
        observer_event_sale_pre_product.unobserve(entry.target);
      }
    });
  });

  document
    .querySelectorAll(".event-sale-pre-product .buy-card")
    .forEach((element) => {
      observer_event_sale_pre_product.observe(element);
    });
}